import React, { useState } from 'react';
import './Bundle.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';
import Loader from '../../UI/Icons/Loader/Loader';

const AddToCartLabel = ({ price, compareAtPrice }) => {
  // Hack
  const discountedPrice = compareAtPrice;
  const calcPrice = discountedPrice || price;
  return (
    <span>
      Add to Cart
      <span className="c-pdp-subnav__price">&nbsp;{calcPrice}</span>
      {discountedPrice && <span className="c-pdp-subnav__original-price">&nbsp;{price}</span>}
    </span>
  );
};

/**
 * Renders a bundle component
 * @param {array} variants
 * @param {object} image
 * @param {string} title
 * @param {string} description
 * @param {function} addToCart
 * @param {string} url
 * @param {string} price
 * @param {array} attributes
 * @param {string} url
 * @returns {JSX.Element}
 * @constructor
 */
const Bundle = ({
  variants,
  image,
  title,
  description,
  price,
  compareAtPrice,
  attributes,
  addToCart,
  url,
}) => {
  const renderContents = (attrs) =>
    attrs.map((attr) => (
      <li className="c-bundle__contents-list-item" key={attr}>
        {attr?.attribute}
      </li>
    ));

  const [fetching, setFetching] = useState(false);

  const properties = {
    quantity: 1,
    id: variants[0]?.id,
  };

  const addAction = async () => {
    setFetching(true);
    await addToCart(properties, title)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    <div className="c-bundle">
      <div className="c-bundle__image">
        <img src={image?.url} alt={image?.alt} />
      </div>
      <div className="c-bundle__text">
        <div className="c-bundle__text-inner">
          <div className="c-bundle__title h3-roobert">
            <h3>
              <a className="color-black" href={url}>
                {title}
              </a>
            </h3>
          </div>
          <div className="c-bundle__description body-2">
            <p>{description}</p>
          </div>
          <div className="c-bundle__contents">
            <span className="eyebrow-2">This pack contains:</span>
            <ul className="c-bundle__contents-list body-2">{renderContents(attributes)}</ul>
          </div>
          <div className="c-bundle__add-to-cart">
            <CTAButton
              isButton={true}
              onClick={addAction}
              ariaLabel={<AddToCartLabel price={price} compareAtPrice={compareAtPrice} />}
              type="primary"
              text={
                fetching ? (
                  <Loader lightMode={true} />
                ) : (
                  <AddToCartLabel price={price} compareAtPrice={compareAtPrice} />
                )
              }
              additionalClasses="cta"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bundle;
